import axios from 'axios';

export const state = {
  buyoffers: [],
  loading: false,
  pagination: {
    dir: 'desc',
    limit: 25,
    page: 1,
    sort: 'created_at',
  },
};

export const mutations = {
  setBuyOffers(context, buyoffers) {
    context.buyoffers = buyoffers;
    context.loading = false;
  },

  setPagination(context, pagination) {
    context.pagination = pagination;
    context.loading = false;
  },

  setLoading(context, value) {
    context.loading = value;
  },
};

export const actions = {
  async fetchBuyOffers({ commit, rootState }, params) {
    try {
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };

      const query = params ? `?${params}` : '';
      commit('setBuyOffers', []);
      commit('setLoading', true);

      const buyoffers = await axios.get(`${window.BASE_API.TRADING_PLATFORM}/orderbook/status/buyoffers/history${query}`, options)
        .then(response => response.data);

      commit('setBuyOffers', buyoffers.data);
      commit('setPagination', buyoffers.pagination);
      commit('setLoading', false);
    } catch (err) {
      commit('setLoading', false);
    }
  },

  async cancelBuyOffersAction({ commit, dispatch, rootState }, data) {
    try {
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };
      commit('setLoading', true);

      data.ids.map(id => axios.delete(`${window.BASE_API.TRADING_PLATFORM}/orderbook/status/buyoffers/${id}/`, options)
        .then(response => response.data));

      commit('setLoading', false);
      dispatch('fetchBuyOffers');
    } catch (err) {
      commit('setLoading', false);
    }
  },
};

const buyOffersStore = {
  state,
  mutations,
  actions,
};

export default buyOffersStore;



// WEBPACK FOOTER //
// ./src/store/trades/buyOffersStore.js